enum TransactionMonitoringIntegrations {
    Comply = 'COMPLY',
    Swisscom = 'SWISSCOM',
    HawkAI = 'HAWK_AI',
}
export default TransactionMonitoringIntegrations